
import { NgModule } from '@angular/core';

import { AuditProvider } from './audit.provider';

export * from './audit.provider';


@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    AuditProvider,
  ]
})
export class AuditBackendModule { }
